import React from "react";
import {cx} from "../../lib/ClassSet";
import "./OrderItem.css";
import format from 'date-fns/format'
import {ExternalOrderTag} from "../../components/MiniTag";

const MetaAggregatedOrderItem = (props) => {

  const {data} = props;

  const withError = data.get("messages").find((a) => a.startsWith("ERROR"));

  const classes = cx({
    "item": true,
    "sales-order-list-item": true,
    "u-selected": props.selected,
    "warning": withError && data.get("state") !== "COMPLETED",
  })

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field">{data.get("metaOrderId")}</td>
      <td className="field">{data.get("shopId")}</td>
      <td className="field">{data.get("state")}</td>
      <td className="field">{data.get("name")}</td>
      <td className="field">{data.get("shippingOrderIds")?.join(", ")}</td>
      <td className="field">{format(data.get("createdAt"), "MMM D, YYYY")}</td>
      <td className="field">{format(data.get("lastUpdatedAt"), "MMM D, YYYY")}</td>
      <td className="field f-x">
        <ExternalOrderTag source={data.get("source")} />
      </td>
    </tr>
  )
}

export default MetaAggregatedOrderItem;